import { Component, inject, OnInit, signal } from '@angular/core';
import { DebugService, DebugState } from '../../../services/debug.service';
import { ClipboardTools } from '../../../tools/clipboard-tools';
import { SolIcon } from '@sol/icons';
import { SolButtonComponent } from '../../core/sol-button/sol-button.component';
import { SolIconComponent } from '../../core/sol-icon/sol-icon.component';
import { SolButtonType } from '../../../models/core/sol-button';
import { SolDebugInfoState } from './sol-debug-info.state';

@Component({
  selector: 'sol-debug-info',
  imports: [SolIconComponent, SolButtonComponent],
  templateUrl: './sol-debug-info.component.html',
  styleUrls: ['./sol-debug-info.component.scss'],
})
export class SolDebugInfoComponent implements OnInit {
  protected readonly SolButtonType = SolButtonType;
  protected readonly SolIcon = SolIcon;

  // State
  protected readonly state$ = signal<SolDebugInfoState>(SolDebugInfoState.of());

  // Dependencies
  private debugService = inject(DebugService);

  ngOnInit(): void {
    this.refresh(this.debugService!.state);
    setInterval(() => {
      this.refresh(this.debugService!.state);
    }, 500);
  }

  private refresh(state: DebugState): void {
    this.state$.set(SolDebugInfoState.fromDebugState(state));
  }

  copyToClipboard(itemName: string, groupName: string) {
    ClipboardTools.copyText(itemName + groupName);
  }

  copyStateToClipboard(itemName: string, groupName: string) {
    const state = this.state$();
    const item = state.groups.find(group => group.name === groupName)!.items.find(item => item.name === itemName)!;
    ClipboardTools.copyText(item.toStates());
  }

  onToggleLogging(itemId: string) {
    this.debugService.toggleLogging(itemId);
  }

  onClear() {
    this.debugService.clear();
  }

  protected onClose(): void {
    this.debugService.toggleVisible();
  }
}
